/* Testimonial Carousel Presets (isolated to avoid Liquid formatter mangling) */
// Move to metafield guru later?
window.truvaniTestimonialCarouselPresets = {
  plantProteinTestimonials: {
    kicker: "bought by over 46,000 people",
    title: "watch how these creators use our protein powder",
    hasButton: true,
    buttonText: "see all our protein flavors",
    buttonHref: "https://shop.truvani.com/pages/protein-kit-bundle-sub",
    testimonials: [
      {
        videoURL: "https://vimeo.com/787942980",
        paragraph:
          "“This actually tastes delicious! It tastes like a chocolate brownie milkshake. My inner child is excited about it! I’m excited about it! It’s so good!”",
        by: "steph a.",
      },
      {
        videoURL: "https://vimeo.com/787942934",
        paragraph:
          "“…these ingredients are very clean, delicious, gluten free and dairy free. My stomach is very sensitive so I love what’s inside this protein powder.”",
        by: "sofia s.",
      },
      {
        videoURL: "https://vimeo.com/787942622",
        paragraph:
          "“Not only it is delicious but it’s gluten free, dairy free, minimal ingredients and I never feel bloated. Truvani is my go to protein powder after every gym session.”",
        by: "danee r.",
      },
    ],
  },
  onlyBarTestimonials: {
    kicker: "over 2 million bars sold",
    title: "see how much these creators love our snack bars",
    hasButton: true,
    buttonText: "see all our bar flavors",
    buttonHref: "https://shop.truvani.com/pages/the-only-bar-sample-pack",
    testimonials: [
      {
        videoURL: "https://vimeo.com/875223728",
        paragraph:
          "“These are only made out of a few ingredients. Cashews, dates, maple syrup, shredded coconut and sea salt. It’ just so simple… Oh my gosh. These are so good!”",
        by: "ivy f.",
      },
      {
        videoURL: "https://vimeo.com/875246303",
        paragraph:
          "“They show you the ingredients in each bar which I just love so you know exactly what you’re eating. They’re gluten free, dairy free, and plant based.”",
        by: "sarah k.",
      },
      {
        videoURL: "https://vimeo.com/875635318",
        paragraph:
          "“The Only Bar is my absolute favorite snack to keep me going throughout the day and I love all the different flavors. I love that it only has a few ingredients and is NON-GMO and Vegan.”",
        by: "ella",
      },
    ],
  },
};
